import { Controller } from "@hotwired/stimulus"
import { render, h } from 'preact'
import { createBeaconStore } from '../modules/beacon/beacon-store.js'
import { BeaconWidget } from '../modules/beacon/components/BeaconWidget.jsx'

/**
 * Beacon Support Widget — Stimulus controller.
 *
 * Mounts the Preact BeaconWidget on <body>, wires the mobile navbar "?"
 * button (open()), and keeps the store's isCompactViewport signal in sync
 * with window resize — same breakpoint (1200px) as the old HelpScout
 * controller (see plan "Mobil böngésző és Expo WebView működés").
 */
export default class extends Controller {
  static values = {
    userId:        String,
    tenantId:      String,
    personId:      String,
    userAvatarUrl: String,
    guideBaseUrl:  String
  }

  connect() {
    this.store = createBeaconStore({
      userId:        this.userIdValue,
      tenantId:      this.tenantIdValue,
      personId:      this.personIdValue,
      userAvatarUrl: this.userAvatarUrlValue,
      guideBaseUrl:  this.guideBaseUrlValue,
    })

    this._mountContainer = document.createElement('div')
    this._mountContainer.id = 'beacon-widget-root'
    document.body.appendChild(this._mountContainer)
    this._renderWidget()

    this.boundResize = () => this.store.updateViewport()
    window.addEventListener('resize', this.boundResize)
  }

  disconnect() {
    if (this.boundResize) {
      window.removeEventListener('resize', this.boundResize)
    }
    if (this._mountContainer) {
      render(null, this._mountContainer)
      this._mountContainer.remove()
      this._mountContainer = null
    }
  }

  _renderWidget() {
    render(h(BeaconWidget, { store: this.store }), this._mountContainer)
  }

  open(event) {
    event?.preventDefault?.()
    this.store?.open()
  }

  toggle(event) {
    event?.preventDefault?.()
    this.store?.toggle()
  }
}
